// extracted by mini-css-extract-plugin
export default {"col":"Grid_col__sBONM","colsk":"Grid_colsk__z6L0b","doorimg":"Grid_doorimg__rhuk-","doorimgsk":"Grid_doorimgsk__NDlmX","cont":"Grid_cont__rnpL+"};